'use strict';

angular.module('app')
    .service('urlMaker', function ($injector) {
        return {
            searchPageUrl: function(params) {
                var utils = $injector.get('utils')
                if (params && params.type === 'fleets') {
                    return utils.createURL(params.type + '/' + params.slug + '/');
                }
                return utils.createURL('/s/' + params.type + '/' + params.slug + '/');
            }
        }
    });
